import { ImageInfo } from './common';
import { CommonRequestOptions, makeRequest } from './makeRequest';

export type SiteInfo = {
   siteid: number;
   name: string;
   domain: string;
   uid: string;
   uid_v2: string;
   custom_domain: string;
   title: string;
   theme: 'white' | 'black' | 'green' | 'orange' | 'blue';
   color: string;
   private: boolean;
   description?: string;
   authentication: {
      standard: boolean;
      'public-registration': boolean;
      sso?: string;
   };
   answers: boolean;
   collections: boolean;
   logo: ImageInfo;
   languages: SiteLanguages;
   [siteSetting: string]: any;
   footer_links: Record<FooterLinkNames, boolean>;
   pendo?: {
      'application-key': string;
      environment: string;
      deployment_type: string;
      customer_type: string;
      salesforce_id: string;
      job_title: string;
      department: string;
      location: string;
      shift: string;
      privilege: string;
      date_created: string;
      last_login: string;
   };
   live_site: boolean;
};

type FooterLinkNames = 'api' | 'contribute' | 'licensing';

export type SiteLanguages = {
   [langid: string]: {
      name: string;
      autoglottonym: string;
      locale: string;
   };
};

export async function getSiteInfo(common: CommonRequestOptions = {}): Promise<SiteInfo> {
   return makeRequest('get', 'sites/info', common);
}
